import "intersection-observer";
import React, { Fragment, useEffect } from "react";
import { renderRoutes } from "react-router-config";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import routes from "./routes";
import BaseElements from "./containers/Helmet/BaseElements";
import AuthModal from "./components/AuthModal/AuthModal";
import PolicyModal from "./components/PolicyModal/PolicyModal";
import { sendPageView } from "./utils/tracking";
import { checkIpadOs } from "./actions/deviceType";

function App(props) {
  const { checkIpadOs, ssrData } = props;
  const location = useLocation();

  useEffect(() => {
    checkIpadOs();
  }, []);

  useEffect(() => {
    sendPageView();
  }, [location]);

  useEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <Fragment>
      <BaseElements />
      {renderRoutes(routes, { ssrData })}
      <PolicyModal />
      <AuthModal />
    </Fragment>
  );
}

function mapStateToProps(state) {
  return {
    ssrData: state.ssrData,
  };
}

const mapActionToProps = {
  checkIpadOs,
};

export default connect(mapStateToProps, mapActionToProps)(App);
